var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"size":"is-small","type":"password","disabled":_vm.field.properties.basic.isDisabled,"password-reveal":_vm.field.properties.basic.isPasswordVisible,"placeholder":"*******"}})}
var staticRenderFns = []

export { render, staticRenderFns }